import './ClosedIcons.less';

const BetRegisteredIcon = ({ height = 26, width = 26, closedBet = false, fill = null }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg"
            className="closing-icon"
        >
            <path
                d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm0 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13zM8 11a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-8a3 3 0 0 1 .852 5.877l-.102.026v.347a.75.75 0 0 1-.648.743L8 10a.75.75 0 0 1-.743-.648L7.25 9.25v-1a.75.75 0 0 1 .648-.743L8 7.5A1.5 1.5 0 1 0 6.5 6 .75.75 0 0 1 5 6a3 3 0 0 1 3-3z"
                fill={fill ? fill : closedBet ? '#1261A0' : '#ff8000'}
                fillRule="nonzero"
            />
        </svg>
    );
};

export default BetRegisteredIcon;
